module.exports = __webpack_public_path__ + "img/inactive.2b1c38d.jpg";